import React, { useState, useEffect } from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";
import ListItem from "./ListItem";
import ShortCutListWrapper from "./ShortCutListWrapper";

function ShortCut({ shortCutList, titleText, info, drawCd }) {
    // 2022-05-30 수정
    const [menuList, setMenuList] = useState([]);
    useEffect(() => {
        shortCutList.reduce((initialValue, currentValue) => {
            if (currentValue["NAME"] !== "백과사전") {
                initialValue.push(currentValue);
                shortCutList = initialValue;
            }
            return initialValue;
        }, []);
        setMenuList(shortCutList);
    }, [shortCutList]);

    return (
        <SubBoxWrapper info={info} disableIcon={true} titleText={titleText} customClassName={"shortCut clear"}>
            <ShortCutListWrapper>
                {menuList.map((info, idx) => (
                    <ListItem
                        key={idx}
                        info={info}
                        categoryType={info.MENU_TY_CD}
                        link={info.LINK}
                        title={info.NAME}
                        drawCd={drawCd}
                    />
                ))}
            </ShortCutListWrapper>
        </SubBoxWrapper>
    );
}

export default ShortCut;
